import { BaseEntity } from '../../../models';
import { OrigemLancamentoCadastro } from '../../../models/origem-lancamento-cadastro';
import { Pessoa } from '../pessoa';
import { transportadoraAtiva } from './transportadora-situacao';

export class Transportadora implements BaseEntity {
    readonly id: number;
    origemCadastro: number;
    idPessoa: number;
    pessoa: Pessoa;
    situacao: number;

    // Importação
    tagImportacao: string;
    dataImportacao: Date;

    // Integração ERP
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: boolean;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    constructor(origemCadastro: OrigemLancamentoCadastro) {
        this.origemCadastro = origemCadastro?.id ?? null;
        this.pessoa = new Pessoa(origemCadastro);
        this.situacao = transportadoraAtiva.id;
    }
}
